import Section from "../components/Section/Section.jsx";
import ArticleContainer from "../components/Article/ArticelContainer.jsx";
import { usePageMeta } from "../hooks/usePageMeta";

function AllArticles() {
  usePageMeta({
    ogType: "website",
    ogUrl: window.location.href,
  });

  return (
    <Section headingText="All Articles">
      <ArticleContainer />
    </Section>
  );
}

export default AllArticles;
